import { useState, useEffect } from 'react';
import { breakpoints } from 'config/config';

interface BreakpointInfo {
  width: number;

  isXs: boolean;
  isSm: boolean;
  isMd: boolean;
  isLg: boolean;

  isXsDown: boolean;
  isSmDown: boolean;
  isMdDown: boolean;
  isLgDown: boolean;
  isXsUp: boolean;
  isSmUp: boolean;
  isMdUp: boolean;
  isLgUp: boolean;
}

export function useBreakpoint(): BreakpointInfo {
  const getInfo = (): BreakpointInfo => {
    const width = window.innerWidth;

    return {
      width,

      isXs: width >= breakpoints.xs && width < breakpoints.sm,
      isSm: width >= breakpoints.sm && width < breakpoints.md,
      isMd: width >= breakpoints.md && width < breakpoints.lg,
      isLg: width >= breakpoints.lg,

      isXsDown: width < breakpoints.xs,
      isSmDown: width < breakpoints.sm,
      isMdDown: width < breakpoints.md,
      isLgDown: width < breakpoints.lg,

      isXsUp: width >= breakpoints.xs,
      isSmUp: width >= breakpoints.sm,
      isMdUp: width >= breakpoints.md,
      isLgUp: width >= breakpoints.lg,
    };
  };

  const [info, setInfo] = useState<BreakpointInfo>(getInfo);

  useEffect(() => {
    const handleResize = () => setInfo(getInfo());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return info;
}
